import { withNestedView } from '@/router/routerHelpers';
const loadView = withNestedView('automations');

const automationsRoutes = [
  {
    path: '/automations',
    component: {
      render: (c) => c('router-view'),
    },
    meta: {
      feature: 'automations',
    },
    children: [
      {
        path: '',
        name: 'automations',
        meta: { showNav: true, feature: 'automations' },
        component: loadView('Automations'),
      },
      {
        path: 'create',
        props: true,
        name: 'automation-create',
        meta: { feature: 'automations' },
        component: loadView('AutomationCreate'),
      },
      {
        path: 'edit/:id',
        props: true,
        name: 'automation-edit',
        meta: { feature: 'automations' },
        component: loadView('form/AutomationForm'),
      },
      {
        path: 'confirm',
        name: 'confirm',
        props: true,
        meta: { feature: 'automations' },
        component: loadView('confirm/AutomationConfirm'),
      },
    ],
  },
];

export default automationsRoutes;
